import { z } from "zod";

export default function parseBoolean() {
    const schema = z.union([z.boolean(), z.enum(["true", "false"])]).transform((val) => {
        if (val === "true") return true;
        if (val === "false") return false;
        return val;
    });

    return schema;
}
